import { FontsType } from '@openeducation/react-native-lesson-player';
import { useFonts } from 'expo-font';

export const fonts: FontsType = {
  primary: {
    regular: {
      fontFamily: 'Proxima-Nova-Regular',
      fontWeight: '400',
    },
    italic: {
      fontFamily: 'Proxima-Nova-Regular-Italic',
      fontWeight: '400',
    },
    light: {
      fontFamily: 'Proxima-Nova-Light',
      fontWeight: '300',
    },
    bold: {
      fontFamily: 'Proxima-Nova-Bold',
      fontWeight: '700',
    },
  },
  secondary: {
    regular: {
      fontFamily: 'Proxima-Nova-Regular',
      fontWeight: '400',
    },
    italic: {
      fontFamily: 'Proxima-Nova-Regular-Italic',
      fontWeight: '400',
    },
    light: {
      fontFamily: 'Proxima-Nova-Light',
      fontWeight: '300',
    },
    bold: {
      fontFamily: 'Proxima-Nova-Bold',
      fontWeight: '700',
    },
  },
};

export const useFontsLoader = () => {
  const [fontsLoaded] = useFonts({
    'Proxima-Nova-Regular-Italic': require('../assets/fonts/Proxima-Nova-Regular-Italic.ttf'),
    'Proxima-Nova-Regular': require('../assets/fonts/Proxima-Nova-Regular.ttf'),
    'Proxima-Nova-Light': require('../assets/fonts/Proxima-Nova-Light.ttf'),
    'Proxima-Nova-Light-Italic': require('../assets/fonts/Proxima-Nova-Light-Italic.ttf'),
    'Proxima-Nova-Bold': require('../assets/fonts/Proxima-Nova-Bold.ttf'),
    'Proxima-Nova-Bold-Italic': require('../assets/fonts/Proxima-Nova-Bold-Italic.ttf'),
  });

  return {
    fontsLoaded,
  };
};
